/**
* SoundEvent.js
* Created on 10-5-2021
* @author Swen Meeuwes for &ranj
**/

class SoundEvent {
    constructor(type) {
        this.type = type;
    }
}

SoundEvent.MUTE = "SoundEvent.MUTE";
SoundEvent.UNMUTE = "SoundEvent.UNMUTE";

export default SoundEvent;